export enum BankIdMethod {
    OTP = "otp",
    Mobile = "mobile",
}
